const state = () => ({
  supervisorMcLinks: [
    {
      name: 'mc.links.supervisor.currentAndFeatures',
      link: '/master-classes/supervisor/current-and-features/'
    },
    {
      name: 'mc.links.supervisor.finished',
      link: '/master-classes/supervisor/finished/'
    },
    {
      name: 'mc.links.supervisor.status',
      link: '/master-classes/supervisor/status-mimk/'
    },
    {
      name: 'mc.links.supervisor.schedule',
      link: '/master-classes/supervisor/timetable/'
    },
    {
      name: 'mc.links.supervisor.statistic',
      link: '/timeslots-statistic'
    },
  ],

  managerMcLinks: [
    {
      name: 'mc.links.manager.registration',
      link: '/master-classes/manager/new-mk/'
    },
    {
      name: 'mc.links.manager.mc',
      link: '/master-classes/manager/master-classes/'
    },
    {
      name: 'mc.links.manager.hourConfirmation',
      link: '/master-classes/manager/hour-confirmation/'
    },
    {
      name: 'mc.links.mimk.schedule',
      link: '/master-classes/manager/my-timetable/'
    },
    {
      name: 'mc.links.manager.statistic',
      link: '/timeslots-statistic'
    },
  ],

  managerMcLinksWithTimetable: [
    {
      name: 'mc.links.manager.registration',
      link: '/master-classes/manager/new-mk/'
    },
    {
      name: 'mc.links.manager.mc',
      link: '/master-classes/manager/master-classes/'
    },
    {
      name: 'mc.links.manager.hourConfirmation',
      link: '/master-classes/manager/hour-confirmation/'
    },
    {
      name: 'mc.links.manager.schedule',
      link: '/master-classes/manager/timetable/'
    },
    {
      name: 'mc.links.mimk.schedule',
      link: '/master-classes/manager/my-timetable/'
    },
    {
      name: 'mc.links.manager.statistic',
      link: '/timeslots-statistic'
    },
  ],

  mimkMcLinks: [
    {
      name: 'mc.links.mimk.currentAndFeatures',
      link: '/master-classes/mimk/current-and-features/'
    },
    {
      name: 'mc.links.mimk.finished',
      link: '/master-classes/mimk/finished/'
    },
    {
      name: 'mc.links.mimk.schedule',
      link: '/master-classes/mimk/timetable/'
    },
  ]
})

  export default {
    namespaced: true,
    state
  };
